<template>
  <div>
    <add-influencer :is-active.sync="isAdding" @added="influencerAdded" />
    <data-table
      title="Escrow Transfers"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :csv="false"
      :archive="false"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />
    </data-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      showArchived: false,
      url: "api/v1/operations",
      headers: this.pairTableLabelWithValue({
        "Recipient Name": "destination_user.full_name",
        "Recipient  Company": "destination_user.company.name",
        "Recipient Country": "destination_user.country",
        "Sender Name": "source_user.full_name",
        "Sender Company": "source_user.company.name",
        "Sender Country": "source_user.country",
        "Applied Fees": "applied_fees.value",
        Amount: "amount_in_euros",
        Status: "status",
      }),
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  methods: {
    showDetails(transaction) {
      this.$router.push({
        name: "escrowTransfers.show",
        params: { payment_id: transaction.payment_id },
      });
    },
  },
};
</script>
